module.exports = __webpack_public_path__ + "media/images/edion/zh/discount-coupon-345f226b7e628b317704f9fc2ab7275a.png";